'use client';

import {
  createContext,
  memo,
  useMemo,
  useContext,
  type PropsWithChildren,
} from 'react';

type SSRMatchMedia = (query: string) => { matches: boolean };

const MediaQueryContext = createContext<{ ssrMatchMedia?: SSRMatchMedia }>({});

interface MediaQueryProviderProps {
  ssrMatchMedia?: SSRMatchMedia;
}

const MediaQueryProvider = memo(
  ({ ssrMatchMedia, children }: PropsWithChildren<MediaQueryProviderProps>) => {
    const memoisedValue = useMemo(() => ({ ssrMatchMedia }), [ssrMatchMedia]);
    return (
      <MediaQueryContext.Provider value={memoisedValue}>
        {children}
      </MediaQueryContext.Provider>
    );
  }
);

const useMediaQueryContext = () => {
  const context = useContext(MediaQueryContext);

  if (!context) {
    throw new Error(
      'Attempted to access MediaQueryContext outside of <ZeusProvider>'
    );
  }

  return context;
};

export { MediaQueryProvider, useMediaQueryContext, type SSRMatchMedia };
